/**
 * Ajoute automatiquement un produit offert au panier quand le produit déclencheur est ajouté.
 * Configuré via Thème > Paramètres > Panier > Produit offert.
 * Le discount doit être géré séparément.
 */
(function () {
  async function addFreeProductIfNeeded(productId) {
    const config = window.freeGiftConfig || {};
    const triggerId = config.triggerProductId || 0;
    const freeVariantId = config.freeProductVariantId || 0;

    if (!triggerId || !freeVariantId) return;
    if (String(productId) !== String(triggerId)) return;

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const freeAlreadyInCart = cart.items.some((item) => item.variant_id === freeVariantId);
    if (freeAlreadyInCart) return;

    const formData = new FormData();
    formData.append('id', freeVariantId);
    formData.append('quantity', 1);

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }
    }

    const addRes = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    });

    const data = await addRes.json();
    if (!data.status && cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
      cartDrawer.renderContents(data);
    }
  }

  function init() {
    if (typeof window.subscribe !== 'function' || typeof window.PUB_SUB_EVENTS === 'undefined') return;

    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (data && data.productId) {
        addFreeProductIfNeeded(data.productId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
